@switch (mode) {
  @case ("dx") {
    <div class="flex flex-1">
      <dx-date-range-box
        [value]="value()"
        [startDatePlaceholder]="startDatePlaceholder || ''"
        [endDatePlaceholder]="endDatePlaceholder || ''"
        [startDateLabel]="''"
        [endDateLabel]="''"
        [showClearButton]="disableResetButton"
        [dropDownOptions]="{
          onInitialized: onDxDateRangePopupInitialized
        }"
        (onValueChanged)="onDxDateRangeSelected($event)"
      ></dx-date-range-box>
    </div>
  }

  @case ("custom") {
    <div class="flex flex-row flex-1 rounded-md bg-slate-100">
      <input
        daterange
        [daterangeCustomPresets]="customPresets()"
        [from]="from"
        [to]="to"
        [disableCustomPresets]="disableCustomPresets"
        [disableResetButton]="disableResetButton"
        (select)="select.emit($event)"
        (clear)="clear.emit($event)"
        [attr.placeholder]="placeholder || null"
        class="flex-1 px-2 text-xs align-middle rounded-md outline-none cursor-pointer bg-slate-100"
      />
      <div class="flex items-center justify-center pr-2">
        <i class="fa-light fa-calendar-range"></i>
      </div>
    </div>
  }
}
